import { PaginacionProps } from "../global/PaginacionInterface";
import { defaultExhortoRecibido, ExhortoRecibidoProps } from "../recepcion/ExhortoRecibidoInterface";

export const defaultBuscarLibroExhortoRecibidoResponse: BuscarLibroExhortoRecibidoResponse = { currentPageIndex: 0, pageCount: 0, recordCount: 0, records: [], };

export const defaultBuscarLibroExhortoRecibido: BuscarLibroExhortoRecibido = { idAutoridad: 0, numeroReferencia: '' };

export const defaultLibroExhortoRecibido: LibroExhortoRecibidoProps = {
    idLibroExhortoRecibido:     0,
    idExhortoRecibido:          0,
    numeroExhorto:              '',
    numeroExpedienteOrigen:     '',
    claseExhorto:               '',
    autoridadExhorto:           '',
    objetoExhorto:              '',
    observaciones:              '',
    exhortoRecibido:            defaultExhortoRecibido,
};


export interface LibroExhortoRecibidoProps {
    idLibroExhortoRecibido:     number;
    idExhortoRecibido:          number;
    numeroExhorto:              string;
    numeroExpedienteOrigen:     string;
    claseExhorto:               string;
    autoridadExhorto:           string;
    objetoExhorto:              string;
    observaciones:              string;
    exhortoRecibido:            ExhortoRecibidoProps;
    fecha?:                     Date;
    fechaDiligencia?:           Date;
    fechaDevolucion?:           Date;
}

export interface BuscarLibroExhortoRecibido {
    idAutoridad:        number;
    numeroReferencia:   string;
}

export interface BuscarLibroExhortoRecibidoParams extends PaginacionProps, BuscarLibroExhortoRecibido { }

export interface BuscarLibroExhortoRecibidoResponse {
    currentPageIndex:   number;
    pageCount:          number;
    recordCount:        number;
    records:            LibroExhortoRecibidoProps[];
}

export interface GuardarObservaciones {
    id:             number;
    observaciones:  string;
}

export interface DescargarInformacionParams { 
    idAutoridad:        number;
    numeroReferencia:   string;
}